<template>
    <div>
        <el-dialog :visible.sync="visible" center :close-on-click-modal="true" @close="handleClose"
      custom-class="dialog_normalsuo dialog_normalpower " :append-to-body="true">
      <div>
         <div class="detail_cont">
        <div class="flex_center">
             <img class="powerdengpao" src="../../assets/images/powerdengpao.png" alt="">
        </div>
          <div class="detail_cont_text">
        The feature you’re attempting to access is part of our premium membership benefits. To gain access to this feature and enjoy full access to premium features, please subscribe to our membership plan.
          </div>

        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export btn_exportCCC" @click="handleClose()">OK</el-button>
        <el-button class="btn_export" @click="GotoPay">Subscribe</el-button>
      </div>
    </el-dialog>
    </div>
</template>

<script>

export default {
  
    data() {
        return {
            visible:false,
            //page: this.currentPage

            token: sessionStorage.getItem('token'),
        };
    },
    computed: {
        newDialog: {
            get() {
                return this.suoClose;
            },
            set() { },
        },

    },
    created() {
        
        this.$bus.$on('show-permission-dialog', (on)=>{
            this.showDialog()
        });
    },
    beforeDestroy() {
        this.$bus.$off('show-permission-dialog', this.showDialog);
    },
    methods: {
      GotoPay(){
        this.$router.push({
          path: '/index/addCredit',
        }).then(()=>{
  this.$router.go(0); // 等待页面路径更新后再刷新页面

      })
      },
        handleClose(value){
            this.visible = false;
        },
        showDialog(value){ 

            this.visible = true;
        },
        //关闭弹窗
   
 
        onSubmitquxiao() {
      this.$router.push({
        path: '/index/addCreditt',
      });
   



        },
    },
};
</script>
<style scoped>
.detail_cont {
    max-height: 85vh;
    overflow: auto;

}


</style>
